//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import CkEditor4MediaEmbed from "./ckEditor4MediaEmbed";

export default class CkEditor4Conversion extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "CkEditor4Conversion";
  }
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [CkEditor4MediaEmbed];
  }
}
